import React, { useContext, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import "./sidemenu.css";
import { MyContext } from "../../context/context";

const gcTechProArr = [
  { gc: "GC1", duration: "1.5 Month" },
  { gc: "GC2", duration: "1 Month" },
  { gc: "GC3", duration: "1 Month" },
  { gc: "GC4", duration: "2 Months" },
  { gc: "GC5", duration: "1 Month" },
  { gc: "GC6", duration: "1 Month" },
  { gc: "GC7", duration: "2 Months" },
  { gc: "GC8", duration: "Mini Project" },
];

const gcSmartProArr = [
  { gc: "GC1", duration: "1.5 Month" },
  { gc: "GC2", duration: "1 Month" },
  { gc: "GC3", duration: "2 Months" },
  { gc: "GC4", duration: "1 Month" },
  { gc: "GC5", duration: "1 Month" },
  { gc: "GC6", duration: "2 Months" },
  { gc: "GC7", duration: "Mini Project" },
];

const Sidebar = () => {
  const { isSidebarOpen, setIsSidebarOpen, activeGC, setActiveGC } =
    useContext(MyContext);

  const sidebarRef = useRef(null);
  const [user] = useState(JSON.parse(localStorage.getItem("student")));

  const getArray = (program) =>
    program === "tech-pro" ? gcTechProArr : gcSmartProArr;

  const handleClickGC = (gc) => {
    setActiveGC(gc);
  };

  return (
    <aside
      className={`course-sidebar ${isSidebarOpen ? "open" : "close"}`}
      ref={sidebarRef}
    >
      <div className="course-sidebar-header">
        <Link to={"/course"} className="gc-link">
          <div className="portal-info">
            <div className="portal-icon">🚀</div>
            <div>
              <h2>IBIX</h2>
              <p>Learning Portal</p>
            </div>
          </div>
        </Link>

        <button
          className="close-course-sidebar"
          onClick={() => setIsSidebarOpen(false)}
        >
          ×
        </button>
      </div>

      <nav className="course-sidebar-nav">
        <div className="nav-section">
          <h4 className="section-label">Student Journey</h4>

          <div className="gc-accordion">
            {getArray(user?.student?.program).map((item) => (
              <div key={item.gc} className="gc-item">
                <Link
                  to={`/${item.gc.toLowerCase()}`}
                  className="gc-link"
                  onClick={() => handleClickGC(item.gc)}
                >
                  <div
                    className={`gc-header ${
                      activeGC.toUpperCase() === item.gc ? "active" : ""
                    }`}
                  >
                    <div className="gc-info">
                      <span className="gc-icon">📚</span>
                      <span className="gc-name">{item.gc}</span>
                      {/* <span className="gc-progress">{item.duration}</span> */}
                    </div>

                    <span
                      className={`gc-arrow ${
                        activeGC.toUpperCase() === item.gc ? "open" : ""
                      }`}
                    >
                      <svg width="12" height="12" fill="none">
                        <path
                          d="M3 4.5L6 7.5L9 4.5"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                  </div>{" "}
                </Link>
              </div>
            ))}
            <p className="certification-text">Get Full Stack Certification</p>
          </div>
        </div>
      </nav>
    </aside>
  );
};

export default Sidebar;
